import { initializeScrollAnimations } from '../utils/animations.js';

// visa.js

document.addEventListener('DOMContentLoaded', function() {
    initializeScrollAnimations();
    // Removed image-loading logic—images stay visible by CSS now
});
